import src from "IMAGE";
export default { src, width: 2, height: 2, blurWidth: 0, blurHeight: 0};
